import {
  subject,
  subject_select,
  topic_select,
} from "@Modules/Subject/configs/constants";

import list_subject from "./reducers";
import list_subject_select from "./reducers/subjectSelect";
import list_topic_select from "./reducers/topicSelect";

export default {
  [subject]: list_subject,
  [subject_select]: list_subject_select,
  [topic_select]: list_topic_select,
};
